import React from "react";
import { Chip } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import CloseIcon from "@mui/icons-material/Close";
import { GROUP_TYPE, IRecentContacts } from "@home-health-notify/domain";
import { ForwardToPanelChipsContainer } from "./ForwardToPanelChips.style";

interface ForwardToPanelChipsProps {
  selectedContacts: IRecentContacts[];
  onRemoveContact: (id: string) => void;
}

const ForwardToPanelChips = ({
  selectedContacts,
  onRemoveContact,
}: ForwardToPanelChipsProps) => {
  return (
    <ForwardToPanelChipsContainer>
      {selectedContacts.map(contact => (
        <Chip
          key={contact.id}
          icon={
            contact.groupType === GROUP_TYPE.PATIENT ? (
              <HomeIcon />
            ) : contact.groupType === GROUP_TYPE.NON_PATIENT ? (
              <GroupsIcon />
            ) : (
              <PersonIcon />
            )
          }
          label={contact.name}
          onDelete={() => onRemoveContact(contact.id)}
          deleteIcon={<CloseIcon />}
          sx={{ fontWeight: 500 }}
        />
      ))}
    </ForwardToPanelChipsContainer>
  );
};

export default ForwardToPanelChips;
